import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Flex, Image, Text} from '@chakra-ui/react'
import StyledContent from '../../styled-content'

const ProductSuggestion = ({suggestion, closeAndNavigate, searchBarPosition}) => (
    <Flex
        gap={4}
        onMouseDown={() =>
            closeAndNavigate(suggestion.link, {
                search_bar_position: searchBarPosition,
                flyout_section: 'Products',
                flyout_selection: suggestion.name
            })
        }
        cursor="pointer"
        alignItems="center"
        width="100%"
        data-testid="product-suggestion-item"
    >
        <Flex
            height="6.4375rem"
            width="5.625rem"
            justifyContent="center"
            alignItems="center"
            flex="0 0 auto"
        >
            {suggestion.image ? (
                <Image maxWidth="100%" maxHeight="100%" src={suggestion.image} alt="" />
            ) : (
                <Flex
                    {...{
                        placeSelf: 'stretch',
                        width: '100%',
                        height: '100%',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        paddingBlock: 3,
                        paddingInline: 2,
                        gap: 3,
                        color: 'stokkeGray.accessibleText',
                        backgroundColor: 'stokkeGray.light'
                    }}
                >
                    <Text
                        textAlign="center"
                        textStyle="Regular Small"
                        maxWidth="100%"
                        isTruncated
                        whiteSpace="normal"
                        noOfLines={2}
                    >
                        <FormattedMessage
                            defaultMessage="Unavailable"
                            id="product_item.discontinued"
                        />
                    </Text>
                </Flex>
            )}
        </Flex>
        <Flex direction="column" gap={4} alignItems="start">
            <StyledContent as={Text} content={suggestion.name} fontWeight="600" textAlign="left" />
        </Flex>
    </Flex>
)

ProductSuggestion.propTypes = {
    suggestion: PropTypes.object.isRequired,
    closeAndNavigate: PropTypes.func,
    searchBarPosition: PropTypes.string
}

export default ProductSuggestion
